import { render, staticRenderFns } from "./DocumentLifecycleActions.vue?vue&type=template&id=ebcb3488&scoped=true&"
import script from "./DocumentLifecycleActions.vue?vue&type=script&lang=js&"
export * from "./DocumentLifecycleActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb3488",
  null
  
)

export default component.exports